import {
  DashboardOutlined,
  RetweetOutlined,
  InfoCircleOutlined,
  TeamOutlined,
  ToolOutlined,
  FormOutlined,
  WarningOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';
import {
  OrderIcon,
  EnterpriseIcon,
  UserIcon,
  PolicyIcon,
} from '@fastlessjs/backoffice-layer/dist/components/atoms';
import { AuthorizedApps } from '@fastlessjs/backoffice-layer/dist/hooks';

import { t } from './translations';

const Menus = (base: AuthorizedApps): AuthorizedApps => {
  const entries = [
    {
      url: 'returns',
      key: 'menus:returns',
      label: t('menu.returns'),
      description: t('menu.returns.description'),
      icon: () => RetweetOutlined,
    },
    {
      url: 'suivi',
      key: 'menus:suivi',
      label: t('menu.suivi'),
      description: t('menu.suivi.description'),
      icon: () => InfoCircleOutlined,
    },
    {
      url: 'orders',
      key: 'menus:orders',
      label: t('menu.orders'),
      description: t('menu.orders.description'),
      icon: () => OrderIcon,
    },
    {
      url: 'enterprises',
      key: 'menus:enterprises',
      label: t('menu.enterprises'),
      description: t('menu.enterprises.description'),
      icon: () => EnterpriseIcon,
    },
    {
      key: 'menus:usersmanagement',
      label: t('menu.iam'),
      description: t('menu.iam.description'),
      icon: () => UserIcon,
      children: [
        {
          key: 'menus:users',
          url: 'users',
          label: t('menu.users'),
          icon: () => UserIcon,
        },
        {
          key: 'menus:groups',
          url: 'groups',
          label: t('menu.groups'),
          icon: () => TeamOutlined,
        },
        {
          key: 'menus:policies',
          url: 'policies',
          label: t('menu.policies'),
          icon: () => PolicyIcon,
        },
      ],
    },
  ];

  return {
    superadmin: [
      {
        url: 'dashboard',
        key: 'menus:dashboard',
        label: 'Dashboard',
        description: 'Indicators and trends by organization',
        icon: () => DashboardOutlined,
      },
      {
        url: 'maintenance-mode',
        key: 'menus:superadmin:maintenance',
        label: 'Maintenance Mode',
        description: 'Enable/disable maintenance for client organizations',
        icon: () => ToolOutlined,
      },
      {
        url: 'feedbacks',
        key: 'menus:feedbacks',
        label: t('menu.feedbacks'),
        description: t('menu.feedbacks.description'),
        icon: () => FormOutlined,
      },
      {
        url: 'return-failures',
        key: 'menus:return-failures',
        label: 'Returns triage',
        description:
          'Browse returns, verify one in Eureka and replay a failed submission',
        icon: () => WarningOutlined,
      },
      {
        url: 'reassort-lots',
        key: 'menus:reassort-lots',
        label: 'Restock lots',
        description: 'Manage trousseau references handled as restock during imports',
        icon: () => ShoppingOutlined,
      },
      ...base.superadmin,
    ],
    whitelabel: [...entries],
  };
};

export default Menus;
